var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFile && _vm.selectedFile.key),expression:"selectedFile && selectedFile.key"}]},[_c('ol',{ref:"crumbs",staticClass:"breadcrumb text-overflow allow-user-select"},_vm._l((_vm.crumbs),function(name,index){return _c('li',{key:`crumb-${index}`},[_vm._v(" "+_vm._s(name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }